<label class="subHeading">Insurer<span *ngIf="isRequired" class="star">*</span></label>
<mat-select *ngIf="!isMultiSelect; else multi" formControlName="insurer" class="insurer" placeholder="Select">
  <mat-option *ngFor="let insurerObj of insurer" [value]="insurerObj.id">
    {{ insurerObj.name }}
  </mat-option>
</mat-select>

<ng-template #multi>
<app-search-dropdown
  [dataSearchKey]="'name'"
  [dataValueKey]="'id'"
  [dataSource]="insurer"
  [control]="insurerControl"
></app-search-dropdown>
</ng-template>
